import styled from "@emotion/styled";
import { GrPagination, GrSelect, GrStack, GrTypography, palette } from "@jnpmedi/grebob";

interface PaginationProps {
  page: number;
  rpp: number;
  count: number | bigint;
  onChangePage: (page: number) => void;
  onChangeRowsPerPage: (rpp: number) => void;
}

export function Pagination({ page, rpp, count, onChangePage, onChangeRowsPerPage }: PaginationProps) {
  return (
    <StyledContainer>
      <StyledRppOptionWrapper>
        <GrTypography type="Content.Caption02" color="grey070">
          View
        </GrTypography>
        <GrSelect<number, false, true> size="small" value={rpp} options={[10, 25, 50, 100]} onChange={(_, v) => onChangeRowsPerPage(v)} />
        <GrTypography type="Content.Caption02" color="grey070">
          Rows
        </GrTypography>
      </StyledRppOptionWrapper>
      <StyledPaginationWrapper alignItems="center" justifyContent="center">
        <GrPagination page={page} count={Math.ceil((Number(count) || 1) / rpp)} size="medium" onChange={(_, v) => onChangePage(v)} />
      </StyledPaginationWrapper>
    </StyledContainer>
  );
}

const StyledContainer = styled(GrStack)({
  position: "relative",
  width: "100%",
  height: "55px",
  boxSizing: "border-box",
  padding: "15px 0px",
  alignItems: "center",
  backgroundColor: palette["white"],
  borderRadius: "0px 0px 6px 6px",
});

const StyledRppOptionWrapper = styled(GrStack)({
  position: "absolute",
  zIndex: 1,
  gap: 8,
  padding: `0px 16px`,
  alignItems: "center",
});

const StyledPaginationWrapper = styled(GrStack)({
  flex: 1,
});
